import * as React from 'react';
import { cn } from '../../lib/utils';

export interface ToggleProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
}

const Toggle = React.forwardRef<HTMLButtonElement, ToggleProps>(
  ({ checked = false, onChange, label, hint, disabled = false }, ref) => {
    const id = React.useId();
    return (
      <div
        className={cn(
          'inline-flex items-start gap-3 text-sm',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
      >
        <button
          ref={ref}
          id={id}
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange?.(!checked)}
          className={cn(
            'flex relative h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors',
            'focus-visible:outline-none focus-visible:shadow-[inset_0_0_0_2px_var(--color-accent)]',
            checked ? 'bg-accent' : 'bg-line',
            disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          <span
            className={cn(
              'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow transition',
              checked ? 'translate-x-5' : 'translate-x-0'
            )}
          />
        </button>
        <label htmlFor={id}>
          <div className="flex flex-col gap-1">
            {label && <span className="font-medium text-ink">{label}</span>}
            {hint && <span className="text-xs text-muted">{hint}</span>}
          </div>
        </label>
      </div>
    );
  }
);
Toggle.displayName = 'Toggle';

export { Toggle };
